export enum SESSION_STORAGE_KEYS {
  HAS_GOOGLE_MAPS_LOADED_ONCE = "HAS_GOOGLE_MAPS_LOADED_ONCE",
}
